<template>
    <div style="padding: 20px">
        <v-overlay :value="loading" :z-index="9999999999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-card>
            <v-toolbar color="indigo" dense>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        class="mr-5"
                        @click="dialog_header_detail = true"
                        small
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon color="primary">mdi-cog</v-icon>
                    </v-btn>
                    </template>
                    <span>Modifica colonne</span>
                </v-tooltip>
                <v-toolbar-title class="white--text"> Ordini </v-toolbar-title>

                <v-spacer></v-spacer>
                <v-switch
                    dark
                    class="mt-6"
                    v-if="cambia_stato_sel == true"
                    v-model="flag_componente"
                    label="Commessa per distinta base"
                ></v-switch>
                <v-spacer></v-spacer>

                <!-- Bottone di cambiamento stato commessa -->
                <Button
                    classe_bottone="mr-5"
                    colore_icona="primary"
                    idForm="COMMESSA"
                    idOggetto="GESTIONE_COMMESSA_STATO"
                    mdi_icona="mdi-order-bool-ascending-variant"
                    testo_tooltip="Gestione Stato"
                    v-on:buttonClick="
                        lista_tabella.length > 0
                            ? (cambia_stato_sel = !cambia_stato_sel)
                            : (cambia_stato_sel = false)
                    "
                />
                <!-- Bottone di invio modifiche dello stato commessa -->
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            :disabled="
                                !(
                                    cambia_stato_sel == true &&
                                    lista_tabella.length > 0
                                )
                            "
                            @click="dialog_show = true"
                            v-on="on"
                            v-bind="attrs"
                            small
                            class="mr-5"
                        >
                            <v-icon color="primary"
                                >mdi-file-cog-outline</v-icon
                            >
                        </v-btn>
                    </template>
                    <span>Crea Commessa</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            :disabled="
                                !(
                                    cambia_stato_sel == true &&
                                    lista_tabella.length > 0
                                )
                            "
                            @click="dialog_impegni = true"
                            v-on="on"
                            v-bind="attrs"
                            small
                            class="mr-5"
                        >
                            <v-icon color="error">mdi-check</v-icon>
                        </v-btn>
                    </template>
                    <span>CHIUDI ORDINE</span>
                </v-tooltip>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            @click="openDialogAdd"
                            small
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon color="primary"> mdi-plus </v-icon>
                        </v-btn>
                    </template>
                    <span>Aggiungi ordine</span>
                </v-tooltip>
                <v-spacer></v-spacer>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            @click="show_filtri = !show_filtri"
                            class="mr-4"
                            small
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon color="purple"> mdi-filter </v-icon>
                        </v-btn>
                    </template>
                    <span>Filtri</span>
                </v-tooltip>

                <v-spacer></v-spacer>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn small @click="goBack" v-bind="attrs" v-on="on">
                            <v-icon color="error">
                                mdi-keyboard-backspace
                            </v-icon>
                        </v-btn>
                    </template>
                    <span>Back</span>
                </v-tooltip>
            </v-toolbar>

            <v-card-text id="mainCardText" class="mt-3">
                <span v-show="show_filtri == true">
                    <InputFiltri :lista_filtri="filtri" @applica_filtri="applicaFiltri"/>
                </span>
             <!--   <v-row v-if="show_filtri" dense>
                    <v-col class="flex-grow-1 flex-shrink-0">
                        <v-autocomplete
                            label="Codice articolo"
                            :items="cod_articoli"
                            dense
                            outlined
                            v-model="filtro_articolo"
                            @change="changeFilters"
                        >
                        </v-autocomplete>
                    </v-col>

                    <v-col class="flex-grow-1 flex-shrink-0">
                        <v-autocomplete
                            label="Famiglia Articolo"
                            :items="famiglie"
                            dense
                            outlined
                            v-model="filtro_famiglia"
                            @change="changeFilters"
                        >
                        </v-autocomplete>
                    </v-col>

                    <v-col class="flex-grow-1 flex-shrink-0">
                        <v-autocomplete
                            label="Codice ordine"
                            :items="cod_ordini"
                            dense
                            outlined
                            v-model="filtro_ordine"
                            @change="changeFilters"
                        >
                        </v-autocomplete>
                    </v-col>

                    <v-col class="flex-grow-1 flex-shrink-0">
                        <v-autocomplete
                            label="Ragione sociale"
                            :items="ragioni_sociali"
                            dense
                            outlined
                            v-model="filtro_ragione"
                            @change="changeFilters"
                        >
                        </v-autocomplete>
                    </v-col>

                    <v-col class="flex-grow-1 flex-shrink-0">
                        <v-text-field
                            label="Data Documento Da"
                            dense
                            outlined
                            v-model="filtro_consegna"
                            @change="changeFilters"
                            type="datetime-local"
                            clearable
                            @click:clear="
                                filtro_consegna = null;
                                changeFilters();
                            "
                        >
                        </v-text-field>
                    </v-col>

                    <v-col class="flex-grow-1 flex-shrink-0">
                        <v-text-field
                            label="Data Documento A"
                            dense
                            outlined
                            v-model="filtro_consegna2"
                            @change="changeFilters"
                            type="datetime-local"
                            clearable
                            @click:clear="
                                filtro_consegna2 = null;
                                changeFilters();
                            "
                        >
                        </v-text-field>
                    </v-col>

                    <v-col class="flex-grow-1 flex-shrink-0">
                        <v-autocomplete
                            label="Codice commessa"
                            :items="cod_commesse"
                            dense
                            outlined
                            v-model="filtro_commessa"
                            @change="changeFilters"
                        >
                        </v-autocomplete>
                    </v-col>

                    <v-col class="flex-grow-1 flex-shrink-0">
                        <v-autocomplete
                            label="Commessa creata"
                            :items="creata_stati"
                            v-model="filtro_creata"
                            @change="changeFilters"
                            dense
                            outlined
                        >
                        </v-autocomplete>
                    </v-col>
                </v-row> -->

                <v-data-table
                    :items="lista_ordini"
                    :headers="headers_ordini"
                >
                    <!-- Bottone dialog di modifica intervento -->
                    <template
                        v-slot:[`item.edit_stato`]="{ item }"
                        v-if="cambia_stato_sel == true"
                    >
                        <v-checkbox
                            v-model="item.edit_stato"
                            :disabled="item.stato_riga != 1"
                        ></v-checkbox>
                    </template>

                    <template v-slot:[`item.crea_commessa`]="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    @click="creaCommesseRiga(item)"
                                    v-on="on"
                                    v-bind="attrs"
                                    small
                                    class="mr-5"
                                    :disabled="item.stato_riga != 1"
                                >
                                    <v-icon color="primary"
                                        >mdi-file-plus-outline</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>Crea Commessa</span>
                        </v-tooltip>
                    </template>

                    <template v-slot:[`item.cod_commessa`]="{ item }">
                        <v-btn small @click="getCommesseOrdine(item)" :color="item.cod_commessa == null ? 'white' : 'green'">
                            <v-icon :color="item.cod_commessa == null ? 'primary' : 'white'">
                                mdi-file-cog-outline
                            </v-icon>
                        </v-btn>
                    </template>
                    <template v-slot:[`item.stato_riga`]="{ item }">
                        {{ item.stato_riga == 1 ? "Aperta" : "Chiusa" }}
                    </template>
                    <template
                        v-slot:[`item.percentuale_avanzamento`]="{ item }"
                    >
                        <!-- v-model="skill" -->
                        <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                                <v-progress-linear
                                    color="light-green"
                                    height="25"
                                    striped
                                    v-bind="attrs"
                                    v-on="on"
                                    :value="item.percentuale_avanzamento"
                                >
                                    <template>
                                        <v-row class="d-flex align-center px-2">
                                            <v-col cols="12" class="py-0">
                                                <strong
                                                    >{{
                                                        item.percentuale_avanzamento
                                                    }}%</strong
                                                >
                                            </v-col>
                                        </v-row>
                                    </template>
                                </v-progress-linear>
                            </template>
                            <p class="py-0 my-0">
                                Quantità totale: {{ item.quantita }}
                            </p>
                            <p class="py-0 my-0">
                                Quantità prodotta: {{ item.qta_prodotto }}
                            </p>
                        </v-tooltip>
                    </template>
                    <template v-slot:[`item.elimina`]="{ item }">
                        <v-btn
                            small
                            @click="deleteOrdini(item)"
                            v-show="item.cod_commessa == null"
                        >
                            <v-icon color="error"> mdi-close </v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-card-text>

            <v-dialog persistent v-model="dialog_show" width="40%">
                <v-card>
                    <v-toolbar dense color="indigo" class="white--text">
                        <v-toolbar-title>Crea Commessa</v-toolbar-title>

                        <v-spacer></v-spacer>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    @click="
                                        creaCommessa();
                                        dialog_show = false;
                                    "
                                    v-bind="attrs"
                                    v-on="on"
                                    small
                                >
                                    <v-icon color="success">mdi-floppy</v-icon>
                                </v-btn>
                            </template>
                            <span>Conferma</span>
                        </v-tooltip>

                        <v-spacer></v-spacer>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    @click="dialog_show = false"
                                    v-bind="attrs"
                                    v-on="on"
                                    small
                                >
                                    <v-icon color="error">mdi-close</v-icon>
                                </v-btn>
                            </template>
                            <span>Annulla</span>
                        </v-tooltip>
                    </v-toolbar>

                    <v-card-text class="mt-4">
                        <h2>
                            Vuoi creare delle commesse con le righe selezionate?
                        </h2>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <!-- DIALOG NUOVO ORDINE -->
            <v-dialog persistent v-model="show_dialog_agg" width="60%">
                <v-card>
                    <v-toolbar dense color="indigo" class="white--text">
                        <v-toolbar-title>Nuovo Ordine</v-toolbar-title>

                        <v-spacer></v-spacer>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    @click="saveOrdine"
                                    v-bind="attrs"
                                    v-on="on"
                                    small
                                >
                                    <v-icon color="success">mdi-floppy</v-icon>
                                </v-btn>
                            </template>
                            <span>Salva</span>
                        </v-tooltip>

                        <v-spacer></v-spacer>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    @click="closeDialogOrdine"
                                    v-bind="attrs"
                                    v-on="on"
                                    small
                                >
                                    <v-icon color="error">mdi-close</v-icon>
                                </v-btn>
                            </template>
                            <span>Chiudi</span>
                        </v-tooltip>
                    </v-toolbar>

                    <v-card-text class="mt-4">
                        <v-row>
                            <v-col>
                                <v-row align="center" justify="center">
                                    <v-col>
                                        <v-autocomplete
                                            label="Codice Articolo"
                                            v-model="ordine_tmp.id_articolo"
                                            :items="lista_articoli"
                                            item-text="cod_articolo"
                                            item-value="id_articolo"
                                            append-outer-icon="mdi-magnify"
                                            @click:append-outer="searchArticolo"
                                            @keydown.enter="searchArticolo"
                                            :key="key_autocomplete"
                                            id="artsch"
                                        >
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-row align="center" justify="center">
                                    <v-col>
                                        <v-text-field
                                            v-model="ordine_tmp.num_documento"
                                            label="Cod. Ordine"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row align="center" justify="center">
                                    <v-col>
                                        <v-autocomplete
                                            :items="lista_clienti"
                                            item-text="ragione_sociale"
                                            item-value="id_anagrafica"
                                            label="Seleziona il cliente"
                                            v-model="ordine_tmp.ragione_sociale"
                                        >
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6">
                                        <v-text-field
                                            type="number"
                                            min="0"
                                            label="Quantità"
                                            v-model="ordine_tmp.quantita"
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col class="mt-2">
                                <v-date-picker
                                    v-model="ordine_tmp.data_documento"
                                    color="primary"
                                    header-color="primary"
                                ></v-date-picker>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <!-- Overlay generico -->
                    <v-overlay :value="caricamento_dati">
                        <v-progress-circular
                            indeterminate
                            size="64"
                        ></v-progress-circular>
                    </v-overlay>
                </v-card>
            </v-dialog>

            <!-- Snackbar -->
            <SnackbarQV ref="SnackbarQV" />
            <!-- Mini dialog per Closing the Ordine -->
            <v-dialog v-model="dialog_impegni" width="unset">
                <v-card>
                    <v-toolbar color="indigo" dense>
                        <v-row>
                            <v-col align="center" cols="4"></v-col>
                            <v-col align="center" cols="4">
                                <v-btn
                                    @click="
                                        setStatoChiuso();
                                        dialog_impegni = false;
                                    "
                                    small
                                >
                                    <span style="color: rgb(76, 175, 80)"
                                        >Conferma Irreversibile</span
                                    >
                                </v-btn>
                            </v-col>
                            <v-col align="right" cols="4">
                                <v-btn @click="dialog_impegni = false" small>
                                    <v-icon color="error"> mdi-close </v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-toolbar>

                    <v-card-text class="pt-3">
                        <div style="display: inline-block; max-width: 500px">
                            <span style="font-size: 15px">
                                Attenzione! Stai chiudendo un ordine aperto. Non
                                sarà più possibile riaprirlo
                            </span>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-card>
        <v-dialog v-model="conferma_dialog" width="30vw">
            <v-card>
                <v-toolbar color="indigo" dense class="rounded rounded-b-0">
                    <v-toolbar-title class="white--text"
                        >Conferma Creazione Commesse</v-toolbar-title
                    >
                    <v-spacer />
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="my-5 mx-2"
                                small
                                @click="confermaCreaCommesse()"
                            >
                                <v-icon color="success"> mdi-check </v-icon>
                            </v-btn>
                        </template>
                        <span>Crea Commesse</span>
                    </v-tooltip>
                    <v-spacer />
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="my-5 mx-2"
                                small
                                @click="conferma_dialog = false"
                            >
                                <v-icon color="error"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text>
                    <h3>
                        La quantita da produrre e la quantita totale delle
                        commesse non sono uguali. Conferma di voler prcedere.
                    </h3>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="commessa_dialog" width="60vw">
            <v-card>
                <v-toolbar color="indigo" dense class="rounded rounded-b-0">
                    <v-toolbar-title class="white--text"
                        >Creazione Commesse</v-toolbar-title
                    >
                    <v-spacer />

                    <v-switch
                        dark
                        class="mt-6"
                        v-model="flag_componente"
                        label="Commessa per distinta base"
                    ></v-switch>
                    <v-spacer />
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="my-5 mx-2"
                                small
                                @click="clickConfermaCreaCommesse()"
                            >
                                <v-icon color="success"> mdi-check </v-icon>
                            </v-btn>
                        </template>
                        <span>Crea Commesse</span>
                    </v-tooltip>
                    <v-spacer />
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="my-5 mx-2"
                                small
                                @click="commessa_dialog = false"
                            >
                                <v-icon color="error"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text>
                    <v-col cols="12">
                        <v-row align="center" justify="center" dense>
                            <v-col cols="4">
                                <p
                                    :style="
                                        ordine_commessa.qta_remain !=
                                        qta_commesse_totale
                                            ? 'color: #ff0000'
                                            : 'color: #000000'
                                    "
                                >
                                    {{
                                        "Da produrre: " +
                                        ordine_commessa.qta_remain
                                    }}
                                </p>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field
                                    label="Numero Commesse"
                                    v-model="num_commesse"
                                    @change="changeNumCommesse"
                                    type="number"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="4">
                                <p
                                    :style="
                                        ordine_commessa.qta_remain !=
                                        qta_commesse_totale
                                            ? 'color: #ff0000'
                                            : 'color: #000000'
                                    "
                                >
                                    {{
                                        "Totale commesse: " +
                                        qta_commesse_totale
                                    }}
                                </p>
                            </v-col>
                        </v-row>
                        <v-row align="center" justify="center" dense>
                            <v-data-table
                                :headers="headers_commesse"
                                :items="temp_commesse"
                                :items-per-page="5"
                                dense
                            >
                                <template
                                    v-slot:[`item.commessa`]="{ item, index }"
                                >
                                    {{
                                        item != null
                                            ? "Commessa " + (index + 1)
                                            : ""
                                    }}
                                </template>
                                <template v-slot:[`item.qta`]="{ item }">
                                    <v-text-field
                                        v-model="item.qta"
                                        @change="updateTotal"
                                        type="number"
                                        dense
                                    ></v-text-field>
                                </template>
                            </v-data-table>
                        </v-row>
                    </v-col>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="commesse_dialog" width="60vw">
            <v-card>
                <v-toolbar color="indigo" dense class="rounded rounded-b-0">
                    <v-toolbar-title class="white--text">{{
                        "Commesse Ordine " +
                        ordine_selezionato.num_documento +
                        " Articolo " +
                        ordine_selezionato.cod_articolo
                    }}</v-toolbar-title>
                    <v-spacer />
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="my-5 mx-2"
                                small
                                @click="commesse_dialog = false"
                            >
                                <v-icon color="error"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text>
                    <v-data-table
                        :items="commesse_ordine"
                        :headers="headers_commesse_ordine"
                    ></v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_delete" width="30vw">
            <v-card>
                <v-toolbar dense color="indigo" class="white--text">
                    <v-toolbar-title>Conferma Eliminazione</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn small @click="confirmDelete()">
                        <v-icon color="success"> mdi-check </v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn small @click="dialog_delete = false">
                        <v-icon color="error"> mdi-close </v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <h3>Sei sicuro di volere eliminare questo elemento?</h3>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- DIALOG MODIFICA COLONNE HEADER -->
        <v-dialog v-model="dialog_header_detail" width="unset" persistent>
        <HeaderDetail
            :key="dialog_header_detail"
            modulo="TABELLA_ORDINI"
            @click_chiudi="dialog_header_detail = false"
            @salvataggio_effettuato="
            getOrdini();
            dialog_header_detail = false;
            "
        />
        </v-dialog>
    </div>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import Button from "@/components/TOOLS/FormComponentPermissions/Button.vue";
import moment from "moment";
import HeaderDetail from '@/components/TOOLS/HeaderDetail.vue';
import InputFiltri from '@/components/TOOLS/InputFiltri.vue';

class Ordine {
    constructor(arg = undefined) {
        if (arg != undefined) {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] =
                    arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
            });
        } else {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] = c.default_val;
            });
        }
    }
    // Metodo per resettare tutte le campi
    reset() {
        const campi = this.setCampi();
        campi.forEach((c) => {
            this[c.nome] = c.default_val;
        });
    }
    setCampi() {
        const campi = [
            { nome: "id_articolo", default_val: null },
            { nome: "cod_ordine", default_val: "" },
            { nome: "ragione_sociale", default_val: "" },
            { nome: "quantita", default_val: null },
            { nome: "consegna", default_val: "" },
            { nome: "cod_commessa", default_val: null },
            { nome: "cod_packaging", default_val: null },
            { nome: "validita", default_val: 1 },
        ];
        return campi;
    }
}

export default {
    name: "",
    components: {
        SnackbarQV,
        Button,
        HeaderDetail,
        InputFiltri
    },
    props: {},
    data() {
        return {
            // Variabili d'appoggio
            tempOrdine: null,
            dialog_delete: false,
            ordine_selezionato: {},
            commesse_dialog: false,
            conferma_dialog: false,
            num_commesse: 1,
            qta_commesse_totale: 0,
            commessa_dialog: false,
            loading: false,
            e1: 1,
            steps: 3,
            cliente: "",
            obj_label: null,
            ordine_tmp: new Ordine(),
            cod_articolo_search: "",
            cod_ordine_search: "",
            cod_ragione_search: "",
            consegna_search: "",
            cod_commessa_search: "",
            cambia_stato_sel: false,
            menu2: false,
            dialog_show: false,
            date: "",
            filtro_creata: "Tutti",
            filtro_articolo: null,
            filtro_famiglia: null,
            filtro_ordine: null,
            filtro_commessa: null,
            filtro_ragione: null,
            filtro_consegna: null,
            filtro_consegna2: null,
            key_autocomplete: 0,
            ordine_commessa: {},

            // Modal
            caricamento_dati: false,
            flag_componente: false,
            show_dialog_agg: false,
            show_filtri: false,
            dialog_add: false,
            dialog_impegni: false,
            dialog_header_detail: false,

            // Array
            famiglie: [],
            tabella_um: [],
            commesse_ordine: [],
            lista_articoli: [],
            lista_clienti: [],
            lista_tabella: [],
            lista_ordini: [],
            cod_articoli: [],
            cod_ordini: [],
            cod_commesse: [],
            ragioni_sociali: [],
            dati_consegna: [],
            temp_commesse: [],

            // Filtri
            filtri: [],
            filtri_query: [],

            creata_stati: ["Tutti", "Si", "No"],
            headers_commesse_ordine: [
                {
                    text: "Codice",
                    value: "cod_commessa",
                    sortable: false,
                },
                {
                    text: "Quantita",
                    value: "quantita",
                },
                {
                    text: "Quantita Prodotta",
                    value: "qnt_prod",
                },
                {
                    text: "Stato",
                    value: "des",
                },
            ],
            headers_ordini: [
                /*{
                    text: "Crea Commessa",
                    value: "crea_commessa",
                    sortable: false,
                },
                {
                    text: "Codice Articolo",
                    value: "cod_articolo",
                },
                {
                    text: "Famiglia Articolo",
                    value: "des",
                },
                {
                    text: "Descrizione Articolo",
                    value: "des_articolo",
                },
                {
                    text: "Codice Ordine",
                    value: "num_documento",
                },
                {
                    text: "Cliente Ragione Sociale",
                    value: "ragione_sociale",
                },
                {
                    text: "Quantità",
                    value: "quantita",
                },
                {
                    text: "Data Documento",
                    value: "data_documento",
                },
                {
                    text: "Consegna",
                    value: "data_consegna",
                },
                {
                    text: "Commesse",
                    value: "cod_commessa",
                },
                {
                    text: "Stato",
                    value: "stato_riga",
                },
                {
                    text: "Avanzamento Ordine",
                    value: "percentuale_avanzamento",
                },
                {
                    text: "Elimina",
                    value: "elimina",
                    sortable: false,
                },*/
            ],
            headers_commesse: [
                { text: "Commessa", value: "commessa" },
                { text: "Quantità", value: "qta" },
            ],
        };
    },
    methods: {
        applicaFiltri(lista_filtri) {
        // Effettua una copia dell'array e dei suoi elementi per valore.
        this.filtri_query = lista_filtri.map((e) => ({ ...e }));
        this.getOrdini();
        },
        
        async gettabella() {
            let request = {
                controller: "Global",
                method: "POST",
                richiesta: {
                    action: "gettabella",
                    token: localStorage.getItem("user_token"),
                    tipo: "UNITA_MISURA",
                    filter: "validita = 1",
                },
            };

            await this.$store
                .dispatch("api", request)
                .then((res) => {
                    this.tabella_um = res.data;
                })
                .catch((ex) => {
                    console.log(ex);
                    this.tabella_um = [];
                });
        },

        clickConfermaCreaCommesse() {
            if (this.ordine_commessa.qta_remain == this.qta_commesse_totale) {
                this.confermaCreaCommesse();
            } else {
                this.conferma_dialog = true;
            }
        },
        changeNumCommesse() {
            this.qta_commesse_totale = this.ordine_commessa.qta_remain;
            const qntCommessa = Math.floor(
                this.ordine_commessa.qta_remain / this.num_commesse
            );
            const remainder =
                this.ordine_commessa.qta_remain -
                qntCommessa * this.num_commesse;
            this.temp_commesse = [];
            for (let i = 0; i < this.num_commesse; i++) {
                this.temp_commesse.push({
                    qta: qntCommessa + (i == 0 ? remainder : 0),
                });
            }
        },
        creaCommesseRiga(item) {
            this.ordine_commessa = JSON.parse(JSON.stringify(item));
            this.ordine_commessa.qta_remain =
                this.ordine_commessa.quantita -
                this.ordine_commessa.qta_prodotto;
            this.num_commesse = 1;
            this.changeNumCommesse();
            this.commessa_dialog = true;
        },
        updateTotal() {
            this.qta_commesse_totale = 0;
            for (const c of this.temp_commesse) {
                this.qta_commesse_totale += parseInt(c.qta);
            }
        },
        deleteOrdini(it) {
            this.tempOrdine = it;
            this.dialog_delete = true;
        },
        async confirmDelete() {
            this.tempOrdine.data_documento = moment(
                this.tempOrdine.data_documento,
                "DD/MM/YYYY"
            ).format("YYYY-MM-DD");

            let tempItem = {
                id_documento: this.tempOrdine.id_documento,
                data_documento: this.tempOrdine.data_documento,
                dettaglio: [
                    {
                        id_documento_dettaglio:
                            this.tempOrdine.id_documento_dettaglio,
                        validita: 0,
                    },
                ],
            };

            let request = {
                controller: "Magazzino",
                method: "PUT",
                richiesta: {
                    action: "setdocumento",
                    token: localStorage.getItem("user_token"),
                    documento: [tempItem],
                },
            };
            //   // console.log(JSON.stringify(request));

            await this.$store.dispatch("api", request).then((res) => {
                console.log("res.data :>> ", res.data);
                if (res.data) {
                    this.$refs.SnackbarQV.print("success", "Ordine Cancellato");
                } else {
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Impossibile salvare l'orine. Errorrre di connessione con il server."
                    );
                }
            });
            await this.getOrdini();
            //is.changeFilters();
            this.dialog_delete = false;
        },
        setStatoChiuso() {
            var ordiniSelezionati = [];
            this.lista_tabella.forEach((e) => {
                if (e.edit_stato) {
                    e.flag_componente = this.flag_componente == true ? 1 : 0;
                    e.stato_riga = 2;
                    ordiniSelezionati.push(e);
                }
                ordiniSelezionati.forEach((it) => delete it.flag_componente);
            });
            let request = {
                controller: "Magazzino",
                method: "PUT",
                richiesta: {
                    action: "setdocumentodettaglio",
                    token: localStorage.getItem("user_token"),
                    documento: ordiniSelezionati,
                },
            };
            this.$store.dispatch("api", request).then((res) => {
                console.log("res.data :>> ", res.data);
                if (res.data) {
                    this.$refs.SnackbarQV.print("success", "Ordine salvato");
                    this.getOrdini();
                }
                //else {
                //   this.$refs.SnackbarQV.print(
                //     "error",
                //     "Impossibile salvare l'orine. Errorrre di connessione con il server."
                //   );
                // }
                this.getOrdini();
                this.dialog_impegni = false;
            });
        },
        async getCommesseOrdine(arg) {
            this.ordine_selezionato = arg;
            this.commesse_ordine = [];
            this.loading = true;
            let request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getcommesseordine",
                    id_documento_dettaglio: arg.id_documento_dettaglio,
                    token: localStorage.user_token,
                },
            };

            this.caricamento_dati = true;

            await this.$store
                .dispatch("api", request)
                .then(async (res) => {
                    this.commesse_ordine = res.data.result;
                })
                .catch((e) => {
                    this.caricamento_dati = false;
                    console.error(e);
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore caricamento commesse"
                    );
                });
            this.loading = false;
            this.caricamento_dati = false;
            this.commesse_dialog = true;
        },
        searchArticolo() {
            this.loading = true;
            let request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getarticoli",
                    cod_articolo:
                        "*" + document.getElementById("artsch").value + "*",
                    token: localStorage.user_token,
                },
            };

            this.caricamento_dati = true;

            this.$store
                .dispatch("api", request)
                .then(async (res) => {
                    if (res.status == 200) {
                        this.caricamento_dati = false;
                        if (res.data != undefined) {
                            this.lista_articoli = res.data.lista;
                            this.key_autocomplete =
                                this.key_autocomplete == 0 ? 1 : 0;
                        }
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server."
                        );
                    }
                    this.loading = false;
                })
                .catch((e) => {
                    this.caricamento_dati = false;
                    console.error(e);
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server."
                    );
                });
        },
        async confermaCreaCommesse() {
            this.loading = true;
            console.log(this.ordine_commessa);
            const request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getcommessamultipla",
                    id_articolo: this.ordine_commessa.id_articolo != null ? this.ordine_commessa.id_articolo : this.ordine_commessa.id_articolo1,
                    token: localStorage.user_token,
                },
            };
            var toCreate = [];
            await this.$store
                .dispatch("api", request)
                .then(async (res) => {
                    console.log(res);
                    for (let i = 0; i < this.num_commesse; i++) {
                        toCreate.push(JSON.parse(JSON.stringify(res.data[0])));
                        toCreate[toCreate.length - 1].quantita =
                            toCreate[toCreate.length - 1].quantita *
                            this.temp_commesse[i].qta;
                        toCreate[toCreate.length - 1].qtaTotale =
                            toCreate[toCreate.length - 1].quantita;
                        toCreate[toCreate.length - 1].qtaTotale_originale =
                            toCreate[toCreate.length - 1].quantita;
                        toCreate[toCreate.length - 1].chkGenera = 1;
                    }
                })
                .catch((e) => {
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore: Impossibile creare commesse: " + e
                    );
                });
            console.log(toCreate);
            var today = new Date();
            for (const t of toCreate) {
                const request2 = {
                    controller: "Magazzino",
                    method: "PUT",
                    richiesta: {
                        action: "setcommessamultipla",
                        tabella: [t],
                        flag_componente: this.flag_componente,
                        data_commessa:
                            today.getFullYear() +
                            "-" +
                            (today.getMonth() + 1) +
                            "-" +
                            today.getDate(),
                        id_documento_dettaglio:
                            this.ordine_commessa.id_documento_dettaglio.toString(),
                        data_consegna:
                            this.ordine_commessa.data_documento.substring(6) +
                            "-" +
                            this.ordine_commessa.data_documento.substring(
                                3,
                                5
                            ) +
                            "-" +
                            this.ordine_commessa.data_documento.substring(0, 2),
                        token: localStorage.user_token,
                    },
                };
                await this.$store
                    .dispatch("api", request2)
                    .then((res) => {
                        console.log(res);
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Commesse create con successo"
                        );
                    })
                    .catch((e) => {
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Errore: Impossibile creare commesse: " + e
                        );
                    });
            }
            this.loading = false;
            this.commessa_dialog = false;
            this.conferma_dialog = false;
            await this.getOrdini();
            //this.changeFilters();
        },
        async creaCommessa() {
            this.loading = true;
            var request;
            var today = new Date();
            var ordiniSelezionati = [];
            var errore = false;

            this.lista_tabella.forEach((e) => {
                if (e.edit_stato) {
                    e.flag_componente = this.flag_componente == true ? 1 : 0;
                    ordiniSelezionati.push(e);
                }
            });

            var tabellaArticoli = [];
            var found = false;

            ordiniSelezionati.forEach((e) => {
                tabellaArticoli.forEach((e2) => {
                    if (e2.id_articolo == e.id_articolo && !found) {
                        e2.quantita += e.quantita;
                        e2.ordini.push(e.id_documento_dettaglio);
                        found = true;
                    }
                });

                if (!found) {
                    console.log("not found");
                    tabellaArticoli.push({
                        id_articolo: e.id_articolo,
                        quantita: e.quantita,
                        ordini: [e.id_documento_dettaglio],
                        commessa: -1,
                        data_documento: e.data_documento,
                        flag_componente: e.flag_componente,
                    });
                }

                found = false;
            });

            console.log(tabellaArticoli);
            console.log(tabellaArticoli[0].ordini.toString());

            for (let i = 0; i < tabellaArticoli.length; i++) {
                console.log("tabellaArticoli[i]", tabellaArticoli[i]);
                const e = tabellaArticoli[i];
                request = {
                    controller: "Magazzino",
                    method: "POST",
                    richiesta: {
                        action: "getcommessamultipla",
                        id_articolo: e.id_articolo,
                        token: localStorage.user_token,
                    },
                };
                await this.$store
                    .dispatch("api", request)
                    .then(async (res) => {
                        if (res.status == 200) {
                            res.data.forEach((e2) => {
                                e2.quantita = e2.quantita * e.quantita;
                                e2.qtaTotale = e2.quantita;
                                e2.qtaTotale_originale = e2.quantita;
                                e2.chkGenera = 1;
                            });

                            // Tolgo i doppi apici dalle descrizioni per convenienza di BE.
                            res.data.forEach((e) => {
                                e.des_articolo = e.des_articolo.replaceAll(
                                    '"',
                                    ""
                                );
                            });

                            request = {
                                controller: "Magazzino",
                                method: "PUT",
                                richiesta: {
                                    action: "setcommessamultipla",
                                    tabella: res.data,
                                    flag_componente:
                                        tabellaArticoli[i].flag_componente,
                                    data_commessa:
                                        today.getFullYear() +
                                        "-" +
                                        (today.getMonth() + 1) +
                                        "-" +
                                        today.getDate(),
                                    id_documento_dettaglio: e.ordini.toString(),
                                    data_consegna:
                                        e.data_documento.substring(6) +
                                        "-" +
                                        e.data_documento.substring(3, 5) +
                                        "-" +
                                        e.data_documento.substring(0, 2),
                                    token: localStorage.user_token,
                                },
                            };
                            await this.$store
                                .dispatch("api", request)
                                .then((res) => {
                                    console.log("sent");
                                    if (res.status == 200) {
                                        e.commessa = res.data.result.toString();
                                        this.cod_commesse.push(
                                            res.data.result.toString()
                                        );
                                        console.log(e.cod_commessa);
                                    } else {
                                        this.$refs.SnackbarQV.print(
                                            "orange",
                                            `Errore: Impossibile creare commessa per articolo ` +
                                                e.cod_articolo
                                        );
                                        errore = true;
                                    }
                                });
                        } else {
                            this.$refs.SnackbarQV.print(
                                "orange",
                                `Errore: Impossibile creare commessa per articolo ` +
                                    e.cod_articolo
                            );
                            errore = true;
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    });
                this.getOrdini();
            }

            ordiniSelezionati.forEach((e) => {
                tabellaArticoli.forEach((e2) => {
                    if (e2.ordini.includes(e.id_documento_dettaglio)) {
                        e.cod_commessa = e2.commessa;
                    }
                });
            });

            this.lista_tabella.forEach((e) => {
                if (e.edit_stato) {
                    e.edit_stato = false;
                }
            });

            if (!errore) {
                this.$refs.SnackbarQV.print("success", "Commesse Create");
            }

            //this.changeFilters();
            this.loading = false;
            this.cambia_stato_sel = false;
        },
        clickChiudiDialogAgg() {
            this.e1 = 1;
            this.dialog_add = false;
        },

        closeDialogOrdine() {
            this.ordine_tmp = new Ordine();
            this.show_dialog_agg = false;
        },

        /*changeFilters() {
            this.lista_ordini = this.lista_tabella.filter(
                (e) =>
                    (this.filtro_articolo == null ||
                        e.cod_articolo == this.filtro_articolo ||
                        this.filtro_articolo == "Tutti") &&
                        (this.filtro_famiglia == null ||
                        e.des == this.filtro_famiglia ||
                        this.filtro_famiglia == "Tutti") &&
                    (this.filtro_ordine == null ||
                        e.num_documento == this.filtro_ordine ||
                        this.filtro_ordine == "Tutti") &&
                    (this.filtro_commessa == null ||
                        e.cod_commessa == this.filtro_commessa ||
                        this.filtro_commessa == "Tutti") &&
                    (this.filtro_ragione == null ||
                        e.ragione_sociale == this.filtro_ragione ||
                        this.filtro_ragione == "Tutti") &&
                    (this.filtro_consegna == null ||
                        (e.data_documento != null &&
                            Date.parse(
                                e.data_documento.substring(6, 10) +
                                    "-" +
                                    e.data_documento.substring(3, 5) +
                                    "-" +
                                    e.data_documento.substring(0, 2)
                            ) > Date.parse(this.filtro_consegna))) &&
                    (this.filtro_consegna2 == null ||
                        (e.data_documento != null &&
                            Date.parse(
                                e.data_documento.substring(6, 10) +
                                    "-" +
                                    e.data_documento.substring(3, 5) +
                                    "-" +
                                    e.data_documento.substring(0, 2)
                            ) < Date.parse(this.filtro_consegna2))) &&
                    (this.filtro_creata == null ||
                        (e.cod_commessa != null &&
                            this.filtro_creata == "Si") ||
                        (e.cod_commessa == null &&
                            this.filtro_creata == "No") ||
                        this.filtro_creata == "Tutti")
            );
        },*/

        getAnagrafica() {
            let searchReq = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getragionesociale",
                    token: localStorage.getItem("user_token"),
                    // des_anagrafica: this.dettaglio.ragione_sociale,
                    tipo_anagrafica: "C",
                },
            };
            this.$store.dispatch("api", searchReq).then((res) => {
                this.lista_clienti = res.data;
            });
        },
        
        async getOrdini() {
            this.loading = true;
            const request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getordinidettaglio",
                    token: localStorage.user_token,
                    filtri: this.filtri_query
                },
            };

            await this.$store
                .dispatch("api", request)
                .then((res) => {
                    if (res.status == 200) {
                        this.lista_ordini = res.data.dettaglio;
                        /*this.lista_tabella = this.lista_ordini;
                        this.lista_tabella.forEach((e) => {
                            if (
                                !this.cod_articoli.includes(e.cod_articolo) &&
                                e.cod_articolo != null
                            ) {
                                this.cod_articoli.push(e.cod_articolo);
                            }
                            if (
                                !this.cod_ordini.includes(e.num_documento) &&
                                e.num_documento != null
                            ) {
                                this.cod_ordini.push(e.num_documento);
                            }
                            if (
                                !this.famiglie.includes(e.des) &&
                                e.des != null
                            ) {
                                this.famiglie.push(e.des);
                            }
                            if (
                                !this.ragioni_sociali.includes(
                                    e.ragione_sociale
                                ) &&
                                e.ragione_sociale != null
                            ) {
                                this.ragioni_sociali.push(e.ragione_sociale);
                            }
                            if (
                                !this.dati_consegna.includes(
                                    e.data_documento
                                ) &&
                                e.data_documento != null
                            ) {
                                this.dati_consegna.push(e.data_documento);
                            }
                            if (
                                !this.cod_commesse.includes(e.cod_commessa) &&
                                e.cod_commessa != null
                            ) {
                                this.cod_commesse.push(e.cod_commessa);
                            }
                        });
                        this.cod_commesse.sort((a, b) =>
                            a < b ? -1 : a > b ? 1 : 0
                        );
                        this.dati_consegna.sort((a, b) =>
                            a < b ? -1 : a > b ? 1 : 0
                        );
                        this.ragioni_sociali.sort((a, b) =>
                            a < b ? -1 : a > b ? 1 : 0
                        );
                        this.cod_ordini.sort((a, b) =>
                            a < b ? -1 : a > b ? 1 : 0
                        );
                        this.cod_articoli.sort((a, b) =>
                            a < b ? -1 : a > b ? 1 : 0
                        );
                        this.cod_commesse.unshift("Tutti");
                        this.famiglie.unshift("Tutti");
                        this.dati_consegna.unshift("Tutti");
                        this.ragioni_sociali.unshift("Tutti");
                        this.cod_ordini.unshift("Tutti");
                        this.cod_articoli.unshift("Tutti");
                        console.log(this.cod_articoli);*/
                        
                        let tmp_headers = res.data.t_header ? res.data.t_header : [];
                        this.headers_ordini = [];
                        this.headers_ordini.push({
                            text: "Crea Commessa",
                            value: "crea_commessa",
                            sortable: false,
                        });
                        tmp_headers.forEach(e => {
                            if(e.visible)
                                this.headers_ordini.push(e);
                        });
                        this.headers_ordini.push({
                            text: "Elimina",
                            value: "elimina",
                            sortable: false,
                        });

                        this.filtri = res.data.filtri ? res.data.filtri : [];
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            `Criticità rilevata, codice stato: ${res.status}.`
                        );
                    }
                    this.loading = false;
                })
                .catch((err) => {
                    this.$refs.SnackbarQV.print(
                        "error",
                        `${JSON.parse(err.response.data.message).result}.`
                    );
                    this.loading = false;
                });
        },
        goBack() {
            this.$router.push("/home/production");
        },
        goToDetail(item) {
            this.$emit(
                "goToDetail",
                [this.obj_label],
                item.modello_report,
                item.id_articolo_packaging_report
            );
        },
        openDialogAdd() {
            this.ordine_tmp.consegna = moment(new Date()).format("YYYY-MM-DD");
            this.getAnagrafica();
            this.show_dialog_agg = true;
        },
        saveOrdine() {
            let i = this.lista_articoli.findIndex(
                (it) => it.id_articolo == this.ordine_tmp.id_articolo
            );
            console.log("i :>> ", i);
            let tempItem = {
                id_documento: this.ordine_tmp.id_documento,
                data_documento: this.ordine_tmp.data_documento,
                id_anagrafica: this.ordine_tmp.ragione_sociale,
                num_documento: this.ordine_tmp.num_documento,
                stato_doc: 0,
                dettaglio: [
                    {
                        cod_articolo: this.lista_articoli[i].cod_articolo,
                        id_documento_dettaglio: -1,
                        id_documento: this.ordine_tmp.id_documento,
                        data_documento: this.ordine_tmp.data_documento,
                        id_anagrafica: this.ordine_tmp.ragione_sociale,
                        num_documento: this.ordine_tmp.num_documento,
                        id_articolo: this.ordine_tmp.id_articolo,
                        quantita: this.ordine_tmp.quantita,
                        stato_doc: 0,
                        validita: 1,
                    },
                ],
            };
            this.show_dialog_agg = false;
            let request = {
                controller: "Magazzino",
                method: "PUT",
                richiesta: {
                    action: "setdocumento",
                    token: localStorage.getItem("user_token"),
                    documento: [tempItem],
                },
            };
            //   // console.log(JSON.stringify(request));

            this.$store.dispatch("api", request).then((res) => {
                if (res.data == 200) {
                    this.$refs.SnackbarQV.print("success", "Ordine salvato");
                    this.getOrdini();
                }
                // else {
                //   this.$refs.SnackbarQV.print(
                //     "error",
                //     "Impossibile salvare l'orine. Errorrre di connessione con il server."
                //   );
                // }
                this.getOrdini();
                this.impostazioniDialog = false;
            });
        },
    },

    created() {},
    computed: {
        formatDate() {
            return this.date ? moment(this.date).format("DD/MM/YYYY") : "";
        },
    },
    async mounted() {
        this.caricamento_dati = true;
        await this.gettabella();
        await this.getOrdini();
        this.caricamento_dati = false;
    },
    watch: {
        steps(val) {
            if (this.e1 > val) {
                this.e1 = val;
            }
        },
        date(val) {
            let value = moment(val, "YYYY-MM-DD").format("DD/MM/YYYY");
            console.log(value);

            if (val !== "") {
                let items_etichette_tmp = [];
                this.lista_ordini.forEach((elem) => {
                    items_etichette_tmp.push(elem);
                });

                // Faccio un array temporaneo

                const res = [];
                /* Filtro gli elementi visualizzati dopo i passaggi precedenti
                 * e li inserisco in "res". */
                items_etichette_tmp.filter((elem) => {
                    if (elem.consegna == value) {
                        res.push(elem);
                    }
                });

                // Modello la risposta provvisoria su "res".
                items_etichette_tmp = res;
                this.lista_tabella = items_etichette_tmp;
            }
        },
        cambia_stato_sel: {
            immediate: true,
            handler() {
                // Se l'elenco commesse è vuoto, non faccio niente.
                if (this.lista_tabella.length == 0) {
                    return;
                }
                /* Se l'utente vuole modificare lo stato delle
                 * commesse, aggiungo una colonna edit_stato. */
                if (this.cambia_stato_sel == true) {
                    let edit_stato = {
                        value: "edit_stato",
                        sortable: false,
                        text: "Seleziona",
                    };
                    this.headers_ordini.unshift(edit_stato);
                    /* Elimino l'header per la modifica */
                    let headers_tmp = this.headers_ordini.filter(
                        (elem) => elem.value != "crea_commessa"
                    );
                    this.headers_ordini = [];
                    this.headers_ordini = headers_tmp;
                    /* Elimino l'header per la cancellazione */
                    headers_tmp = [];
                    headers_tmp = this.headers_ordini;
                    this.headers_ordini = [];
                    this.headers_ordini = headers_tmp;
                } else {
                    /* Se invece l'utente non vuole modificare lo
                     * stato delle commesse, rimuovo la colonna relativa. */
                    let headers_tmp = this.headers_ordini.filter(
                        (elem) => elem.value != "edit_stato"
                    );
                    this.headers_ordini = [];
                    this.headers_ordini = headers_tmp;
                    let tempHeader = {
                        text: "Crea Commessa",
                        value: "crea_commessa",
                        sortable: false,
                    };
                    this.headers_ordini.unshift(tempHeader);
                    /* Aggiungo l'header per la modifica. */
                    // let edit = {
                    //   value: "edit",
                    //   sortable: false,
                    // };
                    // this.headers_ordini.unshift(edit);
                    // /* Aggiungo l'header per la cancellazione. */
                    // let del = {
                    //   value: "delete",
                    //   sortable: false,
                    // };
                    // this.headers_ordini.push(del);
                }
            },
        },
    },
};
</script>
<style scoped></style>
